import { ComponentProps } from 'react';
import { WorksitePopup } from '@karnott/map';

type WorksitePopupProps = ComponentProps<typeof WorksitePopup>;

type Props = {
  worksiteProps: Omit<WorksitePopupProps, 'labels'>;
  labels: WorksitePopupProps['labels'];
};

export function WorksiteTooltip({ worksiteProps, labels }: Props) {
  const { Icons, worksiteType, fromDate, toDate, isInProgress, lastUpdate, actions } = worksiteProps;

  return (
    <WorksitePopup
      Icons={Icons}
      worksiteType={worksiteType}
      fromDate={fromDate}
      toDate={toDate}
      isInProgress={isInProgress}
      lastUpdate={lastUpdate}
      actions={actions}
      labels={labels}
    />
  );
}
